import React, { useEffect, useRef, useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import { useAuth } from "../../../context/AuthProvider";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import AddJobcard from "./AddJobcard";
import ReactPaginate from "react-paginate";
import EditJobcard from "./Editjobcard";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { usePermission } from "../../../context/PermissionContext";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import Table from "../../../constants/Table";
import { AddIcon, RefreshIcon, SearchIcon } from "../../../constants/Icons";
const ListJobCard = ({ isActive }) => {
  const [isSearchTerm, setSearchTerm] = useState("");
  const ProductSuggestionsRef = useRef(null);
  const containerRef = useRef(null);
  const [ProductSuggestions, setProductSuggestions] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const searchInputRef = useRef(null);
  const suggestionRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  // const [totalExpense, setTotalExpense] = useState(0);
  const [totalItem, setTotalItems] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isPreLoading, setPreLoading] = useState(false);
  const [estimateSuggest, setEstimateSuggest] = useState([]);
  const [taskTitleSuggest, setTaskTitleSuggest] = useState([]);
  const [attributesTitleSuggest, setAttributesTitleSuggest] = useState([]);
  const { globelPopupOpen } = usePermission();
  const [status, setStatus] = useState("pending");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  // const [isDeleteData, setDeleteData] = useState();
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  // const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const [jobcardsByStatus, setJobcardsByStatus] = useState({
    pending: [],
    inprogress: [],
    ready: [],
    delivered: [],
    cancelled: [],
  });

  const [jobcardCounts, setJobcardCounts] = useState({
    pending: 0,
    inprogress: 0,
    ready: 0,
    delivered: 0,
    cancelled: 0,
  });

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { isUser } = useAuth();
  const hasFetched = useRef(false);

  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);

  const currentJobcards = jobcardsByStatus[status] || [];

  const handleOpenModal = () => {
    setEditData(null);
    setEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditModalOpen(false);
  };

  const perPage = 10;

  const handleJobCardList = async (page = 0, statusKey = status) => {
    try {
      if (!checkNetwork()) return;
      setPreLoading(true);
      const response = await AxiosInstance.get(
        `module/jobcard/status/filter?status=${statusKey.toUpperCase()}&pageno=${
          page + 1
        }&limit=${perPage}`,
      );
      const results = response.data.results || [];
      setJobcardsByStatus((prev) => ({
        ...prev,
        [statusKey]: results,
      }));
      setTotalItems(response.data.totalItems || 0);
      setTotalPages(response.data.totalPages || 0);
      setCurrentPage(page);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setPreLoading(false);
    }
  };

  const handleSearch = (term) => {
    const upperTerm = term.toUpperCase(); // ✅ Convert to uppercase
    setSearchTerm(upperTerm);
    setHasSearched(true);
    setSelectedProductCode("");

    if (!upperTerm.trim()) {
      setProductSuggestions([]);
      setCurrentPage(0);
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;
        setSuggestionLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;
        const response = await AxiosInstance.get(
          `module/jobcard/search?searchtxt=${upperTerm}`,
          { signal: controllerRef.current.signal },
        );
        if (currentId === requestIdRef.current) {
          setProductSuggestions(response.data.results || []);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setSuggestionLoading(false);
      }
    }, 200);
  };

  const handleOutsideClick = (e) => {
    if (
      ProductSuggestionsRef.current &&
      !ProductSuggestionsRef.current.contains(e.target)
    ) {
      setProductSuggestions([]);
      setHasSearched(false);
    }
  };

  const handleAddPaylater = async (AddData) => {
    try {
      if (!checkNetwork()) return;
      setPreLoading(true);
      const data = {
        titleId: AddData.titleId,
        taskTitle: AddData.taskTitle,
      };
      if (AddData?.amount) {
        data.amount = CurrencyConverter.toSubunit(AddData.amount, "INR");
      }
      if (AddData?.selectedCustomerId) {
        data.customerid = AddData.selectedCustomerId;
      }
      const response = await AxiosInstance.post(`module/jobcard`, data);
      const newJobcard = response.data.results;
      handleCloseModal();
      setJobcardsByStatus((prev) => ({
        ...prev,
        pending: [newJobcard, ...(prev.pending || [])],
      }));
      setEditData({
        ...newJobcard,
        mediaFile: newJobcard.media?.length ? newJobcard.media[0] : null,
        tasks: newJobcard.task || [],
      });
      setEditModalOpen(true);

      setJobcardCounts((prev) => ({
        ...prev,
        pending: (prev.pending || 0) + 1,
      }));
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
    }
  };

  // const handleAddData = async (AddData) => {
  //   await handleAddPaylater(AddData);
  // };

  const openEditModal = async (cItem) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`/module/jobcard/${cItem._id}`);
      const data = response.data.results;
      setEditData({
        ...data,
        createdByUserId: {
          staffName: cItem?.createdByUserId?.staffName || "Admin",
        },
        mediaFile: data.media?.length ? data.media[0] : null,
        tasks: data.task || [],
      });
      setEditModalOpen(true);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
  };

  const handleJobcardUpdate = (updatedJobcard) => {
    const oldStatusKey = Object.keys(jobcardsByStatus).find((key) =>
      jobcardsByStatus[key].some((j) => j._id === updatedJobcard._id),
    );

    // Find the old jobcard (before updating)
    const oldJobcard =
      oldStatusKey &&
      jobcardsByStatus[oldStatusKey].find((j) => j._id === updatedJobcard._id);

    // Merge old customer details if missing
    const mergedJobcard = {
      ...oldJobcard, // keep everything from old first
      ...updatedJobcard, // overwrite only new fields
      customer: updatedJobcard.customer || oldJobcard?.customer,
      customerName: updatedJobcard.customerName || oldJobcard?.customerName,
      customerPhone: updatedJobcard.customerPhone || oldJobcard?.customerPhone,
      customerid: updatedJobcard.customerid || oldJobcard?.customerid,
    };

    const newStatusKey = mergedJobcard?.status?.toLowerCase();

    setJobcardsByStatus((prev) => {
      const updated = { ...prev };
      if (oldStatusKey) {
        updated[oldStatusKey] = updated[oldStatusKey].filter(
          (j) => j._id !== mergedJobcard._id,
        );
      }
      if (!updated[newStatusKey]) updated[newStatusKey] = [];
      updated[newStatusKey] = [mergedJobcard, ...updated[newStatusKey]];
      return updated;
    });

    setJobcardCounts((prev) => {
      const counts = { ...prev };
      if (oldStatusKey && oldStatusKey !== newStatusKey) {
        counts[oldStatusKey] = Math.max(0, (counts[oldStatusKey] || 1) - 1);
        counts[newStatusKey] = (counts[newStatusKey] || 0) + 1;
      }
      return counts;
    });
  };

  const handleJobcardFieldUpdate = (jobcardId, updatedFields) => {
    setJobcardsByStatus((prev) => {
      const updated = { ...prev };
      const statusKey = Object.keys(prev).find((key) =>
        prev[key].some((j) => j._id === jobcardId),
      );

      if (statusKey) {
        updated[statusKey] = updated[statusKey].map((j) => {
          if (j._id !== jobcardId) return j;

          // Keep old customer info if new fields don’t have it
          return {
            ...j,
            ...updatedFields,
            customer: updatedFields.customer || j.customer,
            customerName: updatedFields.customerName || j.customerName,
            customerPhone: updatedFields.customerPhone || j.customerPhone,
            customerid: updatedFields.customerid || j.customerid,
          };
        });
      }
      return updated;
    });
  };

  const handleFieldUpdate = async (jobcardId, field, value) => {
    try {
      if (!checkNetwork()) return;
      const payload = new FormData();

      if (field === "mediaFile" && value instanceof File) {
        payload.append("media", value);
      } else if (field === "attributes" && Array.isArray(value)) {
        payload.append(field, JSON.stringify(value));
      } else if (field === "customerid" && value?._id) {
        payload.append("customerid", value._id);
      } else {
        payload.append(field, value ?? "");
      }

      const res = await AxiosInstance.patch(
        `/module/jobcard/${jobcardId}`,
        payload,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      const updatedData = res.data.results;
      const newStatusKey = updatedData?.status?.toLowerCase();

      let changedFieldData = {};
      if (field === "customerid" && value) {
        changedFieldData = {
          customer: {
            _id: value._id,
            name: value.name,
            phone: value.phone,
          },
        };
      } else {
        changedFieldData = { [field]: updatedData[field] };
      }

      // Update jobcardsByStatus and counts locally
      setJobcardsByStatus((prev) => {
        const updated = { ...prev };
        const oldStatusKey = Object.keys(prev).find((key) =>
          prev[key].some((j) => j._id === jobcardId),
        );
        if (oldStatusKey) {
          updated[oldStatusKey] = updated[oldStatusKey].map((j) =>
            j._id === jobcardId ? { ...j, ...changedFieldData } : j,
          );
          if (oldStatusKey !== newStatusKey) {
            updated[oldStatusKey] = updated[oldStatusKey].filter(
              (j) => j._id !== jobcardId,
            );
          }
        }
        if (!updated[newStatusKey]) updated[newStatusKey] = [];
        if (oldStatusKey !== newStatusKey) {
          updated[newStatusKey] = [updatedData, ...updated[newStatusKey]];
        }
        return updated;
      });
      setJobcardCounts((prev) => {
        const counts = { ...prev };
        const oldStatusKey = Object.keys(jobcardsByStatus).find((key) =>
          jobcardsByStatus[key].some((j) => j._id === jobcardId),
        );

        if (oldStatusKey && oldStatusKey !== newStatusKey) {
          counts[oldStatusKey] = Math.max(0, (counts[oldStatusKey] || 1) - 1);
          counts[newStatusKey] = (counts[newStatusKey] || 0) + 1;
        }
        return counts;
      });

      showAlert("success", `${field} updated successfully`);
      return updatedData;
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSuggestEstimate = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/jobcard/type`);

      setEstimateSuggest(response.data.results || []);
      // setShowtitlePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleTaskSuggestion = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/jobcard/suggestion/task/title`,
      );

      setTaskTitleSuggest(response.data.results || []);
      // setShowtitlePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleAttributesSuggestion = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/jobcard/suggestion/attributes`,
      );
      setAttributesTitleSuggest(response.data.results || []);
      // setShowtitlePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const fetchJobcardCounts = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get("module/jobcard/status/count");
      const counts = response.data.results || {};
      setJobcardCounts({
        pending: counts.PENDING || 0,
        inprogress: counts.INPROGRESS || 0,
        ready: counts.READY || 0,
        delivered: counts.DELIVERED || 0,
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      if (activeIndex >= 0 && ProductSuggestions[activeIndex]) {
        e.preventDefault();
        openEditModal(ProductSuggestions[activeIndex]);
      }
      // else {
      //   e.preventDefault();
      //   handleSearchFind();
      // }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < ProductSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : ProductSuggestions.length - 1,
      );
    }
  };

  useKeyboardTableNavigation({
    isActive,
    containerRef,
    searchTerms: isSearchTerm,
    suggestions: ProductSuggestions,
    modals: {
      isEditModalOpen,
      isModalOpen,
      globelPopupOpen,
    },
    onEnter: openEditModal,
  });

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  // const handleDelete = async () => {
  //   setBtnLoading(true);
  //   try {
  //     if (!checkNetwork()) return;
  //     const data = { expenseid: isDeleteData._id };
  //     const response = await AxiosInstance.delete(
  //       `module/expense/delete-expense`,
  //       {
  //         data: data,
  //       }
  //     );
  //     showAlert("success", Messages.SUCCESS.EXPENSE_DELETED);
  //     setExpenseData((prev) =>
  //       prev.filter((item) => item._id !== isDeleteData._id)
  //     );
  //     setTotalItems((prev) => prev - 1);
  //     setTotalExpense((prevTotal) => prevTotal - response.data.results.amount);
  //     setDeleteModalOpen(false);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestEstimate();
    handleTaskSuggestion();
    handleAttributesSuggestion();
    fetchJobcardCounts();
  }, []);

  useEffect(() => {
    handleJobCardList(currentPage);
  }, [currentPage]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  useEffect(() => {
    if (!isActive) return;

    // small timeout ensures DOM is visible after tab switch
    const timer = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [isActive]);

  const handleRefresh = async () => {
    handleJobCardList(currentPage);
  };

  const renderJobNo = (jobNo) => (
    <span
      className="badge rounded-pill"
      style={{ background: "#ffab1d", color: "#000", border: "none" }}
    >
      {jobNo}
    </span>
  );

  const renderCustomer = (customer) => {
    if (!customer) return "-";

    return (
      <div className="d-flex flex-column">
        <span className="text-nowrap text-heading fw-medium">
          {customer.name}
        </span>
        <span className="text-nowrap">
          <small>+91 {customer.phone}</small>
        </span>
      </div>
    );
  };

  const renderDueDate = (date) => {
    if (!date) return "-";

    return DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(date, isUser?.timezone),
    ).date;
  };

  const renderTask = (tasks = []) => {
    const completed = tasks.filter(
      (t) => t?.status?.toLowerCase() === "completed",
    ).length;

    const total = tasks.filter(
      (t) => t?.status?.toLowerCase() !== "cancelled",
    ).length;

    return (
      <>
        <span className="badge bg-label-spring">{completed}</span> /
        <span className="badge bg-label-space mx-1">{total}</span>
      </>
    );
  };

  const renderPriority = (priority) => {
    if (!priority) return "-";

    const color =
      priority?.toLowerCase() === "high"
        ? "bg-label-danger"
        : priority?.toLowerCase() === "medium"
          ? "bg-label-warning"
          : "bg-label-success";

    return (
      <span className={`badge rounded-pill fs-14 ${color} text-capitalize`}>
        {priority?.toLowerCase()}
      </span>
    );
  };

  const renderAdvance = (amount) => {
    if (!amount || amount <= 0) return "-";

    return (
      <span className="badge rounded-pill bg-label-fall">
        ₹ {CurrencyConverter.toCurrency(amount, "INR")}
      </span>
    );
  };

  const columns = [
    {
      label: "Job No",
      render: (item) => renderJobNo(item.jobNo),
    },
    {
      label: "Title",
      render: (item) => (
        <div className="d-flex flex-column">
          <span className="fw-medium">{item?.title || "Untitled"}</span>
        </div>
      ),
    },
    {
      label: "Customer",
      render: (item) => renderCustomer(item?.customer),
    },
    {
      label: "Due Date",
      render: (item) => renderDueDate(item?.dueDate),
    },
    {
      label: "Task",
      render: (item) => renderTask(item?.task),
    },
    {
      label: "Priority",
      render: (item) => renderPriority(item?.priority),
    },
    {
      label: "Advance Paid",
      render: (item) => renderAdvance(item?.totalAdvancePaid),
    },
  ];

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row">
              <div className="breadcrumb-title pe-3 d-flex align-items-center gap-2">
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleRefresh}
                    disabled={isPreLoading}
                    title="Refresh list"
                  >
                    <RefreshIcon iClass={`${isPreLoading ? "bx-spin" : ""}`}/>
                  </button>
                </div>
                <div className="breadcrumb-title pe-3">List JobCard</div>

                {/* <div className="ms-auto">
            <button
              type="button"
              className="btn btn-primary mt-2 mt-lg-0"
              onClick={handleLink}
            >
              <i className="ng ng-ng-add-icon"></i> Add Estimate
            </button>
          </div> */}
              </div>
              {/* <div className="card-title mb-2 ">List JobCard</div>{" "} */}
              {/* {totalItem} */}
              {/* <div className="ms-auto">
                <div className="dropdown">
                  <button
                    className="btn btn-export"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bx bx-download"></i> Export
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" onClick={exportToCSV}>
                        <i className="bx bx-spreadsheet"></i>{" "}
                        <span className="icon-text">Excel (CSV)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>

            <div className="card radius-10 mb-0">
              <div className="row g-0">
                {/* Left Column (Filters + New JobCard) */}
                <div className="col-md-3 col-lg-2 border-end">
                  <div className="p-3">
                    <button
                      type="button"
                      onClick={handleOpenModal}
                      className="btn w-100 mb-3"
                      style={{
                        background: "#ffab1d",
                        color: "#000",
                        border: "none",
                      }}
                    >
                      <AddIcon iClass={"me-1"}/> New JobCard
                    </button>

                    {[
                      {
                        key: "pending",
                        label: "Pending",
                        icon: "bi bi-hourglass-split",
                        color: "bg-label-warning",
                      },
                      {
                        key: "inprogress",
                        label: "In Progress",
                        icon: "bi bi-arrow-repeat",
                        color: "bg-label-primary",
                      },
                      {
                        key: "ready",
                        label: "Ready",
                        icon: "bi bi-check2-circle",
                        color: "bg-label-blue",
                      },
                      {
                        key: "delivered",
                        label: "Delivered",
                        icon: "bi bi-truck",
                        color: "bg-label-green",
                      },
                      {
                        key: "cancelled",
                        label: "Cancelled",
                        icon: "ng ng-ng-delete-icon",
                        color: "bg-label-danger",
                      },
                    ].map((opt) => (
                      <button
                        key={opt.key}
                        className={`btn w-100 text text-start d-flex justify-content-between align-items-center mb-1
    ${status === opt.key ? opt.color + " text-white" : "text-muted"}`}
                        onClick={() => {
                          setStatus(opt.key);
                          setPreLoading(true);
                          setCurrentPage(0);
                          handleJobCardList(0, opt.key);
                        }}
                        style={{
                          border: "none",
                          boxShadow: "none",
                          transition: "background 0.2s ease",
                        }}
                      >
                        <span>
                          <i className={`${opt.icon} me-1`}></i> {opt.label}
                        </span>
                        {jobcardCounts[opt.key] > 0 &&
                          opt.key !== "delivered" &&
                          opt.key !== "cancelled" && (
                            <span
                              className={`badge rounded-pill bg-label-primary `}
                            >
                              {jobcardCounts[opt.key]}
                            </span>
                          )}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Right Column (Table + Search) */}
                <div className="col-md-9 col-lg-10">
                  <div className="p-3">
                    <div className="row ">
                      <div className="col-lg-4 col-12 mb-2 mb-lg-0">
                        <div className="position-relative">
                          <div
                            className="input-group"
                            ref={ProductSuggestionsRef}
                          >
                            <input
                              type="text"
                              className="form-control"
                              ref={searchInputRef}
                              onChange={(e) => {
                                handleSearch(e.target.value);
                                setActiveIndex(-1);
                              }}
                              onKeyDown={handleSuggestionNavigation}
                              placeholder="Search jobcard by jobno..."
                              autoFocus
                            />
                            <button
                              className="input-group-text"
                              // onClick={handleSearchFind}
                            >
                              <SearchIcon/>
                            </button>
                          </div>

                          {hasSearched &&
                            isSearchTerm &&
                            !suggestionLoading &&
                            ProductSuggestions.length === 0 && (
                              <ul className="suggestions-list">
                                <li className="suggestion-item text-muted">
                                  No JobCard data was found
                                </li>
                              </ul>
                            )}

                          {ProductSuggestions.length > 0 && (
                            <ul className="suggestions-list">
                              {ProductSuggestions.map((product, index) => (
                                <li
                                  key={product._id}
                                  ref={(el) =>
                                    (suggestionRefs.current[index] = el)
                                  }
                                  onClick={() => openEditModal(product)}
                                  className={`suggestion-item ${
                                    index === activeIndex
                                      ? "active-suggestion"
                                      : ""
                                  }`}
                                >
                                  {/* <span className="badge rounded-pill bg-label-navy">
                                                         {product.code}
                                                       </span>{" "}
                                                       -
                                                       <span className="badge rounded-pill bg-label-retro">
                                                         {product.hsnsac}
                                                       </span>{" "}
                                                       - */}
                                  {product.title} -{" "}
                                  <span
                                    className="badge  rounded-pill"
                                    style={{
                                      background: "#ffab1d",
                                      color: "#000",
                                      border: "none",
                                    }}
                                  >
                                    {product.jobNo}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                      {/* <div className="col-lg-2  col-6 d-flex align-items-center">
                        <div>
                          <strong>Total JobCard:</strong>{" "}
                          <span className="badge btn-label-primary fs-15 ">
                            {totalItem || 0}
                          </span>
                        </div>
                      </div> */}
                    </div>

                    {/* Table */}
                    {/* <div className="table-responsive  mt-2">
                      <table className="table  align-middle mb-0">
                        <thead className="table-light text-center ">
                          <tr>
                            <th>Job No</th>
                            <th>Title</th>
                            <th>Customer</th>
                            <th>Due Date</th>
                            <th>Task</th> */}
                    {/* <th>Task Completed</th> */}
                    {/* <th>Priority</th>
                            <th>Advance Paid</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isPreLoading ? (
                            [...Array(8)].map((_, index) => (
                              <tr key={index}>
                                <td className="text-center">
                                  <Skeleton variant="text" width={100} />
                                </td>
                                <td className="text-center">
                                  <Skeleton variant="text" width={100} />
                                </td>
                                <td className="text-center">
                                  <Skeleton variant="text" width={150} />
                                </td>
                                <td className="text-center">
                                  <Skeleton variant="text" width={50} />
                                </td>
                                <td className="text-center">
                                  <Skeleton variant="text" width={120} />
                                </td> */}
                    {/* <td className="text-center">
                                  <Skeleton variant="text" width={100} />
                                </td> */}
                    {/* <td className="text-center">
                                  <Skeleton variant="text" width={100} />
                                </td>
                                <td className="text-center">
                                  <Skeleton variant="text" width={100} />
                                </td>
                              </tr>
                            ))
                          ) : currentJobcards.length > 0 ? (
                            currentJobcards.map((item, index) => (
                              <tr
                                key={item._id || index}
                                className="cursor-pointer hover-row"
                                onClick={() => openEditModal(item)}
                                data-item={JSON.stringify(item)}
                              >
                                <td className="text-center">
                                  <span
                                    className="badge rounded-pill"
                                    style={{
                                      background: "#ffab1d",
                                      color: "#000",
                                      border: "none",
                                    }}
                                  >
                                    {item.jobNo}
                                  </span>
                                </td>

                                <td className="text-center">
                                  <div className="d-flex flex-column">
                                    <span className="fw-medium">
                                      {item.title} 
                                    </span>*/}
                    {/* <small className="text-muted">
                                      {item?.description}
                                    </small> */}
                    {/* </div>
                                </td>

                                <td className="text-center">
                                  <div className="d-flex flex-column">
                                    <span className="text-nowrap text-heading fw-medium">
                                      {item.customer
                                        ? `${item.customer.name}`
                                        : ""}
                                    </span>
                                    <span className="text-nowrap">
                                      <small>
                                        {item.customer
                                          ? `+91 ${item.customer.phone}`
                                          : " - "}
                                      </small>
                                    </span>
                                  </div>
                                </td>

                                <td className="text-center">
                                <div className="d-flex flex-column">
                                    <span className="text-nowrap text-heading fw-medium">
                                      {item?.dueDate ? DateConverter.ISOToDisplayFormat(
                                      DateConverter.convertToTimeZone(
                                        item?.dueDate,
                                        isUser?.timezone
                                      )
                                    ).date:"-"}
                                  </span> 
                                </div>
                                </td>

                                <td className="text-center">
                                  <span className="badge bg-label-spring">
                                    {item?.task
                                      ? item.task.filter(
                                          (t) =>
                                            t.status?.toLowerCase() ===
                                            "completed"
                                        ).length
                                      : 0}
                                  </span>{" "}
                                  /
                                  <span className="badge bg-label-space mx-1">
                                    {item?.task
                                      ? item.task.filter(
                                          (t) =>
                                            t.status?.toLowerCase() !==
                                            "cancelled"
                                        ).length
                                      : 0}
                                  </span>
                                </td> */}

                    {/* ✅ Completed Task Count
                                <td className="text-center">
                                  {item?.task
                                    ? item.task.filter(
                                        (t) =>
                                          t.status?.toLowerCase() ===
                                          "completed"
                                      ).length
                                    : 0}
                                </td> */}

                    {/* <td className="text-center">
                                  {item.priority ? (
                                    <span
                                      className={`badge rounded-pill fs-14 ${
                                        item.priority.toLowerCase() === "high"
                                          ? "bg-label-danger"
                                          : item.priority.toLowerCase() ===
                                            "medium"
                                          ? "bg-label-warning"
                                          : "bg-label-success"
                                      } text-capitalize`}
                                    >
                                      {item.priority.toLowerCase()}
                                    </span>
                                  ) : (
                                    " - "
                                  )}
                                </td>

                                <td className="text-center">
                                  {item?.totalAdvancePaid &&
                                  item.totalAdvancePaid > 0 ? (
                                    <span className="badge rounded-pill bg-label-fall">
                                      ₹{" "}
                                      {CurrencyConverter.toCurrency(
                                        item.totalAdvancePaid,
                                        "INR"
                                      )}
                                    </span>
                                  ) : (
                                    " - "
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center p-2">
                                <span className="text-muted">
                                  No jobcard found. Add some to get started.
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div> */}
                    <div ref={containerRef}>
                      <Table
                        loading={isPreLoading}
                        columns={columns}
                        data={currentJobcards}
                        onRowClick={openEditModal}
                      />
                    </div>
                    {/* Pagination */}
                    <div className="row align-items-center mt-3">
                      <div className="col text-center">
                        {totalPages > 0 && (
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setPreLoading(true);
                              setCurrentPage(selected);
                              handleJobCardList(selected);
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination justify-content-center mb-0"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {isModalOpen && (
            <AddJobcard
              onClose={handleCloseModal}
              isBtnLoading={isBtnLoading}
              onAdd={handleAddData}
              estimateSuggest={estimateSuggest}
              setEstimateSuggest={setEstimateSuggest}
              titleSuggest={taskTitleSuggest}
            />
          )} */}

          {isEditModalOpen && (
            <EditJobcard
              isActive={isActive}
              onClose={closeEditModal}
              editData={isEditData}
              onJobcardUpdate={handleJobcardUpdate}
              onFieldUpdate={handleFieldUpdate}
              titleSuggest={taskTitleSuggest}
              attributeSuggest={attributesTitleSuggest}
              handleJobcardFieldUpdate={handleJobcardFieldUpdate}
              setTitleSuggest={setEstimateSuggest}
              jobcardTitleSuggest={estimateSuggest}
            />
          )}
          {/* {isDeleteModalOpen && (
            <DeleteModal
              onClose={() => setDeleteModalOpen(false)}
              onConfirm={handleDelete}
              isLable={" Expense " + isDeleteData?.title}
              isBtnLoading={isBtnLoading}
            />
          )} */}
        </div>
      </div>
    </>
  );
};

export default ListJobCard;
